import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { TypeOption } from '@ngx-formly/core/lib/services/formly.config';
import { NgbRatingFieldTypeComponent } from './ngb-rating-field-type/ngb-rating-field-type.component';


@NgModule({
  declarations: [NgbRatingFieldTypeComponent],
  imports: [
    CommonModule,
    NgbRatingModule,
    ReactiveFormsModule,
  ],
  exports: [
    NgbRatingFieldTypeComponent
  ]
})
export class FormlyNgbRatingModule {
  static getNgRatingType(): TypeOption {
    return {
      name: 'ngb-rating',
      component: NgbRatingFieldTypeComponent,
      wrappers: ['form-field']
    };
  }
}
